<section class="rounded-xl border border-amber-300 bg-amber-50 px-4 py-4 space-y-4">
  <div>
    <p class="text-[13px] font-semibold text-amber-900">Fianza reembolsable pendiente</p>
    <p class="mt-1 text-[12px] leading-relaxed text-amber-800">
      Faltan menos de 48 horas para el evento. Debes dejar constancia de la fianza de
      <strong>{{ depositEur() | number:'1.2-2' }}&nbsp;€</strong> antes del inicio.
    </p>
  </div>

  @if (booking.securityDepositStatus === 'submitted') {
    <p class="text-[12px] text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2">
      @if (booking.securityDepositMethod === 'cash') {
        Has indicado pago en efectivo. El propietario confirmará la recepción el día del evento.
      } @else if (booking.securityDepositMethod === 'card_hold') {
        Retención en tarjeta registrada. No necesitas hacer nada más.
      } @else {
        Justificante enviado. El propietario debe validar la fianza.
      }
    </p>
  } @else {
    @if (loadingOptions()) {
      <p class="text-[12px] text-amber-800">Cargando métodos de pago&hellip;</p>
    } @else if (error() && availableMethods().length === 0) {
      <p class="text-[12px] leading-relaxed text-amber-900">{{ error() }}</p>
      <button type="button" (click)="retryLoad()"
        class="mt-1 text-[12px] font-semibold text-action-blue underline underline-offset-2">
        Reintentar
      </button>
    } @else if (availableMethods().length === 0) {
      <p class="text-[12px] leading-relaxed text-amber-900">
        El propietario aún no tiene ningún método de cobro activo para la fianza.
        Contacta con él o con soporte.
      </p>
    } @else {
    <div class="flex flex-col gap-2" role="radiogroup" aria-label="Método de fianza">
      @for (method of availableMethods(); track method) {
        <button type="button"
          (click)="selectMethod(method)"
          class="rounded-xl border px-3 py-2.5 text-left text-[12px] font-semibold transition-colors"
          [class.border-midnight-indigo]="selectedMethod() === method"
          [class.bg-white]="selectedMethod() === method"
          [class.border-amber-200]="selectedMethod() !== method"
          [class.bg-amber-50/50]="selectedMethod() !== method"
          [class.text-midnight-indigo]="selectedMethod() === method"
          [class.text-amber-900]="selectedMethod() !== method">
          {{ methodLabel(method) }}
        </button>
      }
    </div>

    @if (selectedMethod() === 'transfer' || selectedMethod() === 'bizum') {
      @if (ownerPayment(); as pay) {
        <dl class="rounded-xl border border-amber-200 bg-white/80 p-3 space-y-2 text-[12px]">
          @if (selectedMethod() === 'transfer' && pay.iban) {
            <div class="flex justify-between gap-3">
              <dt class="text-steel-gray">Titular</dt>
              <dd class="font-semibold text-midnight-indigo text-right">{{ pay.accountHolder }}</dd>
            </div>
            <div class="flex justify-between gap-3">
              <dt class="text-steel-gray">IBAN</dt>
              <dd class="font-mono font-semibold text-midnight-indigo text-right break-all">{{ formatIban(pay.iban) }}</dd>
            </div>
          }
          @if (selectedMethod() === 'bizum' && pay.mobilePhone) {
            <div class="flex justify-between gap-3">
              <dt class="text-steel-gray">Bizum</dt>
              <dd class="font-semibold tabular-nums text-midnight-indigo">{{ pay.mobilePhone }}</dd>
            </div>
          }
        </dl>
      }

      <div>
        <p class="text-[11px] font-semibold uppercase tracking-wider text-amber-900">Justificante</p>
        <input #receiptInput type="file" accept=".pdf,image/*" class="hidden" (change)="onReceiptSelected($event)" />
        <button type="button"
          (click)="triggerReceiptInput(receiptInput)"
          class="mt-2 w-full rounded-xl border border-dashed border-amber-300 bg-white px-3 py-3 text-[12px] text-amber-900">
          @if (receiptFileName()) {
            {{ receiptFileName() }}
          } @else {
            Subir PDF o imagen del pago
          }
        </button>
      </div>
    }

    @if (selectedMethod() === 'cash') {
      <p class="text-[12px] leading-relaxed text-amber-900">
        Pagarás la fianza en efectivo en el local el día del evento. El propietario la confirmará al recibirla.
      </p>
    }

    @if (selectedMethod() === 'card_hold') {
      <p class="text-[12px] leading-relaxed text-amber-900">
        Se retendrá {{ depositEur() | number:'1.2-2' }}&nbsp;€ en tu tarjeta (sin cobro inmediato). Se liberará tras el evento si no hay incidencias.
      </p>
    }

    @if (error()) {
      <p class="text-[12px] text-red-700">{{ error() }}</p>
    }

    <button type="button"
      (click)="submit()"
      [disabled]="!canSubmit()"
      class="w-full rounded-xl bg-midnight-indigo px-4 py-2.5 text-[13px] font-semibold text-white
             hover:brightness-110 disabled:opacity-40 disabled:cursor-not-allowed">
      @if (submitting()) {
        Enviando&hellip;
      } @else if (selectedMethod() === 'card_hold') {
        Retener en tarjeta
      } @else {
        Confirmar fianza
      }
    </button>
    }
  }
</section>
